<template>
  <div class="menuItem">
    <div v-for="item in treeData" :key="item.id" class="item">
      <el-submenu v-if="item.type === '2' && item.sub && item.sub.length" :index="`${item.id}`" >
        <template slot="title">
          <i class="icon iconfont" :class="item.icon"></i>
          <span class="name" v-if="!showtext">{{item.name}}</span>
        </template>
        <MenuItem v-if="item.sub && item.sub.length" :treeData="item.sub"/>
      </el-submenu>
      <el-menu-item v-else-if="item.name === '首页'" :index="`${item.path}`">
        <i class="icon iconfont" :class="item.icon"></i>
        <span class="name" v-if="!showtext">{{item.name}}</span>
      </el-menu-item>
      <el-menu-item v-else-if="item.type === '1'" :index="`${item.path}`">
        <!-- <template slot="title">
        </template> -->
        <i class="icon iconfont" :class="item.icon"></i>
        <span class="name">{{item.name}}</span>
      </el-menu-item>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'MenuItem',
    props: { 
      treeData:{
        type:Array
      },
      showtext:{
        type:Boolean,
        default:true
      }
    },
    methods: {
    }
  }
</script>

<style lang="scss" scoped>

.menuItem {
  width: 100%;
}
.icon {
  color: #fff;
}
.item {
  margin-top: 0.5vw;
  .is-active {
    color: #0a65ca !important;
  }
}
.name{
  display: inline-block;
  text-align:left;
  margin-left: 0.1vw;
  margin-right:0.5vw;
}
.icon{
  margin-left: 0.5vw;
  margin-right: 0.3vw;
  margin-top: -1px;
  font-size: 22px!important;
  vertical-align: middle;
}
</style>